export default __webpack_public_path__ + "b6e37b33963b08c1df344c11be1cc204.woff";